function setupTabClick(buttonSelector, itemSelector, className = 'active') {
  $(function() {
    $(buttonSelector).on('click', function() {
      $(buttonSelector + ', ' + itemSelector).removeClass(className);

      $(this).addClass(className);

      let index = $(buttonSelector).index(this);
      $(itemSelector).eq(index).addClass(className);
    });
  });
}
setupTabClick('.download-device-tab-btn', '.download-device-list', 'active');
setupTabClick('.download-detail-tab-btn', '.download-detail-content', 'active');
